import Component, { mixins } from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs';
import PageBase from '@common/PageBase';
import * as q from '@Organizations/Users/Domain/queries';

@Component
export default class VuePageQueries extends mixins(PageBase, VueCqrs) {
	runCurrentUserQueryV1(ensureGlobalAdminRole: boolean, ensureOrganizationAdminRole: boolean, ensureAnyAdminRole: boolean)
	{
		const query = q.buildCurrentUserQueryV1(ensureGlobalAdminRole, ensureOrganizationAdminRole, ensureAnyAdminRole);
		this.$query(query);
	}

	runOrganizationAdminCandidatesQueryV1(organizationUnitId: number)
	{
		const query = q.buildOrganizationAdminCandidatesQueryV1(organizationUnitId);
		this.$query(query);
	}

	runPasswordPolicyQueryV1()
	{
		const query = q.buildPasswordPolicyQueryV1();
		this.$query(query);
	}

	runSearchAllUsersQueryV1(organizationUnitId: number, searchPhrase: string, includeActive: boolean, includeLocked: boolean, includeDeleted: boolean)
	{
		const query = q.buildSearchAllUsersQueryV1(organizationUnitId, searchPhrase, includeActive, includeLocked, includeDeleted);
		this.$query(query);
	}

	runStartupDetailsQueryV1()
	{
		const query = q.buildStartupDetailsQueryV1();
		this.$query(query);
	}

	runUserAccessRequestsQueryV1(organizationUnitId: number, includeRequested: boolean, includeRejected: boolean)
	{
		const query = q.buildUserAccessRequestsQueryV1(organizationUnitId, includeRequested, includeRejected);
		this.$query(query);
	}

	runUserDashboardQueryV1()
	{
		const query = q.buildUserDashboardQueryV1();
		this.$query(query);
	}

	runUserQueryV1(userId: string)
	{
		const query = q.buildUserQueryV1(userId);
		this.$query(query);
	}

}
